import moment from "moment";

export const getEventErrorMessage = (intl, error) => {
  const responseStatus = error?.response?.status || error?.status;
  const responseData = error?.response?.data;

  if (responseStatus === 409 && responseData?.collision_data) {
    const hasMaxConcurrentTime = responseData.collision_data.some(e => e.max_concurrent_time != null);
    const headerKey = hasMaxConcurrentTime ? "errors.event.maxConcurrentTime" : "errors.event.sameHour";
    const itemKey = hasMaxConcurrentTime ? "errors.event.maxConcurrentTime.item" : "errors.event.sameHour.item";

    const collisionEventErrorMessages = responseData.collision_data
      .map(collisionEvent => {
        const isRestricted = !collisionEvent.event_title && !collisionEvent.customer_description;
        const messageKey = isRestricted ? `${itemKey}.restricted` : itemKey;

        return intl.formatMessage(
          { id: messageKey },
          {
            ...collisionEvent,
            eventStartDate: moment.unix(collisionEvent.event_start_date).format("lll"),
            eventEndDate: moment.unix(collisionEvent.event_end_date).format("lll"),
            eventTitle: collisionEvent.event_title,
            customerDescription: collisionEvent.customer_description,
            maxConcurrentTime: collisionEvent.max_concurrent_time,
          },
        );
      })
      .join(", ");

    const headerParams = hasMaxConcurrentTime
      ? { maxConcurrentTime: responseData.collision_data[0].max_concurrent_time }
      : {};
    return `${intl.formatMessage({ id: headerKey }, headerParams)} ${collisionEventErrorMessages}`;
  } else if (responseStatus === 409) {
    return responseData?.["409"] || intl.formatMessage({ id: "errors.event.concurrentEventsNotAllowed" });
  } else if (responseStatus === 403) {
    return intl.formatMessage({ id: "errors.event.exceededHours" });
  }

  return null;
};

export const handleEventSubmitError = intl => ({ error, setFieldError, defaultSubmitErrorHandler, ...rest }) => {
  const message = getEventErrorMessage(intl, error);

  if (message) {
    setFieldError("general", message);
  } else {
    defaultSubmitErrorHandler({ error, setFieldError, defaultSubmitErrorHandler, ...rest });
  }
};
